import * as React from 'react';
import { useGetList, LinearProgress } from 'react-admin';
import SMeter from './SMeter';

const UserProfileCount = ({ style = {} }) => {
	const { data: profileRecordData, isError, isLoading } = useGetList(
		'UserProfile',
		{
			pagination: { page: 1, perPage: 5000 },
			sort: { field: 'updatedAt', order: 'DESC' },
			filter: {},
		},
	);

	const { data: tradeUnionRecordData, isTUError, isTULoading } = useGetList(
		'TradeUnion',
		{
			pagination: { page: 1, perPage: 5000 },
			sort: { field: 'updatedAt', order: 'DESC' },
			filter: {},
		},
	);

	if (!isLoading && isError) { return 'error'; }
	if (isLoading) { return <LinearProgress />; }
	if (!profileRecordData) { return 'no user profile data'; }

	if ((!isLoading && isError) || (!isTULoading && isTUError)) { return 'error'; }
	if (isLoading || isTULoading) { return <LinearProgress />; }
	if (!profileRecordData) { return 'no user profile data'; }
	if (!tradeUnionRecordData) { return 'no trade union data'; }

	const profileAggregatedData = profileRecordData.reduce(
		(a, v) => {
			const tradeUnionId = v.tradeUnion && v.tradeUnion.id;
			return a.set(tradeUnionId, a.has(tradeUnionId) ? a.get(tradeUnionId) + 1 : 1);
		},
		new Map(),
	);
	const array = Array.from(profileAggregatedData.entries())
		.sort(([, k1], [, k2]) => (k1 - k2));
	const values = array.map((v) => v[1]);
	const labels = array
		.map((v) => tradeUnionRecordData.find((tu) => tu.id === v[0]))
		.map((v) => (v && v.shortTitle) || 'не указан');

	return (
		<SMeter
			data={values}
			labels={labels}
			style={style}
			title="Пользователи по ППО"
		/>
	);
};

export default UserProfileCount;
